import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/login/device')({
  component: DeviceLoginLayoutRoute,
})

function DeviceLoginLayoutRoute() {
  return <Outlet />
}
